<script context="module">
  export const selector = ".local-city-services__widget";
</script>

<script lang="ts">
  import { onMount } from "svelte";
  import { userStore } from "../stores/UserStore";
  import {
    fetchSearchAddress,
    fetchPricingResults,
    fetchServiceTypesByZipcode,
  } from "./LocalCityServicesBlock";
  import Select from "svelte-select/Select.svelte";
  import type {
  Frequency,
    PricingSearchRequest,
    PricingSearchResponse,
    ServiceType,
    WasteType,
  } from "../../../typings/GetAQuote";
  import { init } from "svelte/internal";
  import { BusinessType } from "../../../typings/SustainabilityCalculator";

  
  export let addressFromPage: string = ""; // only provided when on city page or child page
  export let serviceTypeIdFromPage: number = 0; // only provided when on city type page or child page
  export let businessTypeIdFromPage: string = ""; // only provided when on city type page or child page
  export let materialTypeIdFromPage: string = ""; // only provided when on city type page or child page

  export let apiGetSearchAddress: string = "";
  export let apiGetSearchAddressReverse: string = "";
  export let apiExistingCustomer: string = "";
  export let apiServiceTypes: string = "";
  export let apiGetAllServiceTypesProxy: string = "";
  export let apiPricingSearch: string = "";
  export let apiPricingSubmit: string = "";

  // location
  const { userAddress, userGeoCoords } = userStore;

  // results and modals
  let pricingSearchResponse: PricingSearchResponse = null;
  let searchStatusMessageHidden: boolean = true;

  function initCityServices() {

    fetchSearchAddress(apiGetSearchAddress, addressFromPage).then((response) => {
      console.log('response', response);


      if (!response?.results.length) return;

      const result = response?.results[0];
      const address = result.address;
      const position = result?.position;

      fetchServiceTypesByZipcode(apiServiceTypes,
        address.postalCode,
        position?.lat || 0,
        position?.lon || 0,
      )
        .then((serviceTypesResponse) => {
          console.log('fetch response', serviceTypesResponse);
          if (serviceTypesResponse.status === 204) {
            // if status === 204, show "no services available" block
            console.log('fetch response status', serviceTypesResponse.status);
          } else {

            let serviceType: ServiceType = serviceTypesResponse?.serviceTypes?.find((st) => st.serviceTypeId === serviceTypeIdFromPage);
            let businessType;
            if (serviceType.businessTypes) {
              businessType = serviceType.businessTypes.find((b) => b.name === businessTypeIdFromPage);
            }
            let materialType: WasteType = serviceType?.wasteTypes?.find(wt => wt.code === materialTypeIdFromPage) || serviceType.wasteTypes.find(wt => wt.default);
            let serviceFrequency: Frequency = materialType?.frequencies?.find((f) => f.default);
            
            const queryParams: PricingSearchRequest = {
              postalCode: address.postalCode,
              city: address.localName,
              serviceTypeId: serviceType?.serviceTypeId || serviceTypeIdFromPage,
              businessTypeId: businessType?.businessTypeId,
              materialTypeId: materialType?.materialTypeId,
              serviceFrequencyId: serviceFrequency?.serviceFrequencyId,
              latitude: position?.lat || 0,
              longitude: position?.lon || 0,
              numberOfDays: serviceFrequency?.numberOfPickups || 1,
              isExistingCustomer: false,
            };

            fetchPricingResults(apiPricingSearch, queryParams)
              .then((response) => {
                if (response.status == 200) {
                  pricingSearchResponse = response;
                } else {
                  console.log('fetch call failed', response);
                }
              })
              .catch((_) => {
                console.log('fetch call error', _);
              });
            
          }
        })
        .catch((_) => {
          console.log('fetch call error', _);
        });
    })
    .catch((_) => {
      console.log('fetch call error', _);
    });
    
  }

  onMount(async () => {
    console.log('onMount');
    initCityServices();
  });
</script>

<div class="container">
  <div class="card-list card-type--box card-type--box-free-form bg-win-gray-lightest force-two-up component">
    {#if pricingSearchResponse?.results?.length}
      <div class="row row-cards">
        {#each pricingSearchResponse?.results as result (result)}

          <div class="col-md">
            <div class="card">
                <div class="card-image">
                  {#if result.viewDetailsUrl}
                    <a href="{result.viewDetailsUrl}">
                        <img class="img-fluid" src="{result.image}">
                    </a>
                  {:else}
                    <img class="img-fluid" src="{result.image}">
                  {/if}
                </div>

                <div class="card-body">
                    <div class="card-body-content">
                        
                        <h3 class="card-title">{result.title}</h3>
                        
                            <div class="rich-text">
                              {#if result.subtitle}
                                <p><strong>{result.subtitle}</strong></p>
                              {/if}
                              
                              {@html result.description}    
                            </div>
                        
                    </div>
                </div>
                {#if result.viewDetailsUrl}        
                  <div class="card-actions">
                    <a href="{result.viewDetailsUrl}" class="btn btn-primary">{pricingSearchResponse.cardLabelViewDetails}</a>
                  </div>
                {/if}
            </div>

          </div>
        {/each}
      </div>
    {/if}
  </div>

</div>
